import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelSettingsOperatorsAddResolverErrorStatesEnum {
    GetRolesFailed = ErrorStateScheduleEnum.PanelSettingsOperatorsAddResolverStatesStartIndex,
    RolesNotFound
}
